var map = {
	"./2C.png": "a97f",
	"./2D.png": "2cea",
	"./2H.png": "92d1",
	"./2S.png": "8cd0",
	"./3C.png": "bbbf",
	"./3D.png": "bf7f",
	"./3H.png": "9297",
	"./3S.png": "2c75",
	"./4C.png": "a3dd",
	"./4D.png": "e473",
	"./4H.png": "0a06",
	"./4S.png": "790e",
	"./5C.png": "39ba",
	"./5D.png": "3b5f",
	"./5H.png": "2b0e9",
	"./5S.png": "cef4",
	"./6C.png": "b722",
	"./6D.png": "50a0",
	"./6H.png": "b241",
	"./6S.png": "224d",
	"./7C.png": "3756",
	"./7D.png": "eb0b",
	"./7H.png": "2683",
	"./7S.png": "b290",
	"./8C.png": "146f",
	"./8D.png": "04f7",
	"./8H.png": "d755",
	"./8S.png": "62a2",
	"./9C.png": "e6f8",
	"./9D.png": "cd48",
	"./9H.png": "40e4",
	"./9S.png": "4a7d",
	"./AC.png": "1466",
	"./AD.png": "83e2",
	"./AH.png": "69a7",
	"./AS.png": "581d",
	"./JC.png": "e337",
	"./JD.png": "6942",
	"./JH.png": "261e",
	"./JS.png": "e393",
	"./KC.png": "3d2f",
	"./KD.png": "5300",
	"./KH.png": "6c4b",
	"./KS.png": "b1ac",
	"./QC.png": "32c6",
	"./QD.png": "c01e",
	"./QH.png": "20cd",
	"./QS.png": "9d9b",
	"./TC.png": "c987",
	"./TD.png": "04f5",
	"./TH.png": "d78d",
	"./TS.png": "70ed",
	"./WW.png": "ffbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6501";